import {
  DestroyRef,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Event as RouterEvent,
  NavigationEnd,
  NavigationError,
  Router,
} from '@angular/router';
import { ChunkRecoveryService } from './chunk-recovery';

export function provideChunkRecovery(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const destroyRef = inject(DestroyRef);
    const router = inject(Router);
    const recovery = inject(ChunkRecoveryService);

    function handleRouterEvent(event: RouterEvent): void {
      if (event instanceof NavigationError) {
        recovery.recoverNavigation(event.error, event.url);
        return;
      }

      if (event instanceof NavigationEnd) {
        recovery.clearNavigationRecovery(event.url);
        recovery.clearNavigationRecovery(event.urlAfterRedirects);
      }
    }

    router.events.pipe(takeUntilDestroyed(destroyRef)).subscribe(handleRouterEvent);
  });
}
